import axios from "axios";
import { useRef } from "react";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import ActionBtn from "src/components/ActionBtn";
import FlatIcon from "src/components/FlatIcon";
import { formatDate, formatDateTime } from "src/helpers/utils";
import AddPrescriptionModal from "./AddPrescriptionModal";

const ClinicPrescription = ({ patient }) => {
	const { id } = useParams();
	const add_prescription_modal = useRef(null);
	const [data, setData] = useState([]);
	useEffect(() => {
		if (id > 0) {
			getPrescriptions();
		}
	}, [id]);
	const getPrescriptions = () => {
		axios
			.get(`/v1/clinic/patient-prescription?patient_id=${id}`)
			.then((res) => {
				let a = res.data.data || [];
				setData(a.reverse());
			});
	};
	return (
		<div className="py-2 px-4 flex flex-col">
			<div className="flex items-center gap-4 pb-2">
				<h2 className="text-lg font-bold text-darker mb-0">
					Patient Prescriptions History
				</h2>
				<ActionBtn
					onClick={() => {
						add_prescription_modal.current.show({
							id: id,
							name: `${patient?.lastname}, ${patient?.firstname}, ${patient?.middle}`,
						});
					}}
					size="sm"
				>
					<FlatIcon icon="rr-plus" />
					Add Prescription
				</ActionBtn>
			</div>
			<div class=" mx-11">
				<ol class="relative border-l border-gray-200 dark:border-gray-700">
					{data?.length == 0 ? (
						<li className="text-placeholder pl-4">
							<i>No data to display.</i>
						</li>
					) : (
						""
					)}
					{data?.map((item) => {
						return (
							<li class="mb-10 ml-4">
								<div class="absolute w-3 h-3 bg-gray-200 rounded-full -left-1.5 border border-white dark:border-gray-900 dark:bg-gray-700" />
								<time class="mb-1 text-sm font-normal leading-none text-gray-400 dark:text-gray-500">
									{formatDateTime(
										item?.date + " " + item?.time
									)}
								</time>
								{/* <h3 class="text-lg font-semibold text-gray-900">
									{item?.title}
								</h3> */}
								<div
									class="mb-4 text-base font-normal text-darker bg-yellow-100 rounded-lg p-4 shadow-sm html-contents"
									dangerouslySetInnerHTML={{
										__html: item?.description,
									}}
								/>
							</li>
						);
					})}
				</ol>
			</div>

			<AddPrescriptionModal
				ref={add_prescription_modal}
				getData={getPrescriptions}
			/>
		</div>
	);
};

export default ClinicPrescription;
